import * as React from 'react';
import { State, RouteKey, Selectors, Actions } from '@grandvisionhq/auth';
import { LoaderScreen } from '@grandvisionhq/common';
import { connect } from '@grandvisionhq/state';

class Protected extends React.Component {
    componentDidMount() {
        this.returnPath = window.location.pathname.replace('//', '/').replace(/^\//, '');
        if (State.isInitialized(this.props.auth)) {
            /**
       * If a page was rendered on the server and the user makes their initial landing in our application, we recover
       * their running Auth0 session. This is similar to "assertSession", but we're checking the session for a different reason.
       */ this.props.recoverSession();
        } else if (State.isLoggedOut(this.props.auth)) {
            this.redirectOut();
        } else {
            /**
       * When a user changes their password their Auth0 session ends, and they need to log in again before they can
       * make authenticated requests. When the user navigates to a protected page, we want to know if the user still has
       * a valid session. If they don't, they should be redirected out of my-account directly and any user data should
       * not be visible or accessible anymore.
       */ this.props.assertSession();
        }
    }
    render() {
        const { auth  } = this.props;
        if (State.isLoggedIn(auth)) {
            return this.props.children;
        }
        return /*#__PURE__*/ React.createElement(LoaderScreen, {
            height: 50
        });
    }
    componentDidUpdate() {
        if (State.isLoggedOut(this.props.auth)) {
            this.redirectOut();
        }
    }
    constructor(...args){
        super(...args);
        this.redirectOut = ()=>{
            const query = this.returnPath ? `returnPath=${encodeURIComponent(`/${this.returnPath}`)}` : undefined;
            this.props.goto({
                route: RouteKey.Login,
                query,
                fullPageRefresh: true
            });
        };
    }
}
const mapStateToProps = (state)=>({
        auth: Selectors.getAuth(state)
    })
;
const mapDispatchToProps = {
    goto: Actions.goto,
    recoverSession: Actions.LoginActions.recoverSession,
    assertSession: Actions.LoginActions.assertSession
};
var Protected$1 = connect(mapStateToProps, mapDispatchToProps)(Protected);

export { Protected, Protected$1 as default, mapDispatchToProps, mapStateToProps };
//# sourceMappingURL=Protected.js.map
